module.exports = __webpack_public_path__ + "img/3.00f88f4b.png";